import type { UseModule } from '~/types'

export const install: UseModule = ({ router }) => {
  router.isReady().then(async () => {
    const { registerSW } = await import('virtual:pwa-register')
    registerSW({ immediate: true })
  })
}
